import { Form, Formik } from "formik";
import React, { useEffect } from "react";
// import "react-phone-input-2/lib/material.css";

import { useLocalStorage } from "../../../hooks";

import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/20/solid";
import { useDispatch, useSelector } from "react-redux";
import customer_name from "../../../assets/customer_name.svg";
import { useToast } from "../../../provider/ToastProvider";
import { loadingState, setActionLoading } from "../../../redux/reducers/loadingReducer";
import axiosInstance from "../../../utils/axiosInstance";
import { getUrlForBookings, getUrlForClasses, getUrlForUsers } from "../../../utils/confighelpers";
import SuccessParticipantModal from "../../../components/SuccessParticipantModal";
import { TwButton, TwFormHelperText, TwInputGroup, TwPhoneInputGroup } from "../../../components/tailwind";
import TwAutocomplete from "../../../components/tailwind/TwAutocomplete";
import { cutString } from "../../../helpers";

import profile_img from "../../../assets/avatar_placeholder.svg";


export default function AddClassParticipantForm({
  open,
  handleClose,
  scheduleDetail,
  scheduleId,
  isPackage,
  handleUpdate,
}) {
  // console.log("scheduleId", scheduleId);
  // console.log("scheduleDetail", scheduleDetail);

  const formikInitialValues = {
    username: "",
    fullName: "",
    email: "",
    selectedMember: {},
    countryName: "nl",
    countryCode: "",
    phone: "",
    formattedPhone: "",
  };
  const { addSuccessToast, addErrorToast, addNotificationDialog } = useToast();
  const dispatch = useDispatch();
  const loadingReduxState = useSelector(loadingState);
  const [fullName, setFullName] = React.useState("");
  const [phoneNumber, setPhoneNumber] = React.useState("");
  const [bookingId, setBookingId] = React.useState("");
  const [successModalOpen, setSuccessModalOpen] = React.useState(false);
  const [myMembersList, setMyMembersList] = React.useState([]);
  const [selectedMember, setSelectedMember] = React.useState({});

  const handleSuccessOpen = () => setSuccessModalOpen(true);
  const handleSuccessClose = () => setSuccessModalOpen(false);

  const getMyClubMembers = async (searchText = "") => {
    let mgMember = [];
    const config = {
      method: "get",
      url: `${getUrlForClasses("")}getMyClubMembers?invite=used&getall=true&businessId=${scheduleDetail?.addedByUserId}${(scheduleDetail?.classId?._id || scheduleDetail?.classId) ? `&classId=${scheduleDetail?.classId?._id || scheduleDetail?.classId}` : ``}${searchText && searchText !== "" && searchText.length !== "" ? `&searchText=${searchText}` : ``}`,
    };
    // dispatch(setSectionLoading(true));
    const memberRequest = await axiosInstance(config);
    // dispatch(setSectionLoading(false));
    if (memberRequest.status === 200 && memberRequest.data.data !== undefined) {
      if (memberRequest.data.data.length) {
        for (const item of memberRequest.data.data) {
          mgMember.push({
            label: item.consumer_detail.fullName,
            id: item._id,
            data: item
          });
        }
      }
      console.log("mgMember", mgMember);

      setMyMembersList(mgMember);
    }
  };

  const getMatchedVoucher = (d) => {
    let returnres = { status: false, data: {} }
    if (d.purchase_detail && Array.isArray(d.purchase_detail)) {
      let selectedVoucher = d.purchase_detail.find((f) => {
        if (
          (f.total_voucher_unused != undefined
            && parseInt(f.total_voucher_unused) > 0)
          || (
            f.productType != undefined && f.productType == "subscription" ? (f.unlimitedCredits != undefined && f.unlimitedCredits == true ? true : false) : false
          )
        ) {
          if (f.classId != undefined
            && Array.isArray(f.classId)) {
            if (f.classId.length <= 0) {
              return true;
            } else if (f.classId.indexOf(scheduleDetail?.classId?._id || scheduleDetail?.classId || "") !== -1) {
              return true;
            }
          }
        }
        return false;
      })
      if (selectedVoucher) {
        returnres = { status: true, data: selectedVoucher }
      }
    }
    return returnres;
  }

  useEffect(() => {
    if (open === true) {
      setSelectedMember({})
    }
  }, [open])


  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        className="relative z-50"
      >
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />
        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <DialogPanel
              transition
              className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
            >
              <div className="absolute right-0 top-0 pr-4 pt-4 sm:block">
                <button
                  type="button"
                  onClick={handleClose}
                  className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-0 focus:ring-indigo-500 focus:ring-offset-2"
                >
                  <span className="sr-only">Close</span>
                  <XMarkIcon aria-hidden="true" className="size-6" />
                </button>
              </div>
              <div className="sm:flex sm:items-center">
                <div className="mt-3 text-center sm:mx-4 sm:mt-0 sm:text-left w-full min-h-80">
                  <DialogTitle as="h3" className="text-xl font-semibold text-gray-900">
                    Add Participant
                  </DialogTitle>
                  <div className="mt-6">
                    <Formik
                      initialValues={formikInitialValues}
                      validate={(values) => {
                        console.log("values", values);

                        const errors = {};
                        if (!values.username) {
                          errors.username = "Required!";
                        }
                        if (!values.fullName) {
                          errors.username = "Required!";
                        }
                        if (!values.email) {
                          errors.username = "Required!";
                        }
                        if (values.selectedMember && Object.keys(values.selectedMember).length > 0) {
                          let getMatchedVoucherDetail = getMatchedVoucher(values.selectedMember)
                          if (getMatchedVoucherDetail.status == false) {
                            errors.username = "This member do not have any credits to book this session.";
                          }
                        } else {
                          errors.username = "This member do not have any credits to book this session.";
                        }
                        console.log("errors", errors);

                        return errors;
                      }}
                      onSubmit={async (values, { setSubmitting, resetForm, setErrors }) => {
                        console.log("scheduleDetail._id ==scheduleId", scheduleDetail._id == scheduleId);

                        let body = {
                          scheduleClassId: scheduleDetail?._id || "",
                          type: "add",
                          isPackage: scheduleDetail?.isPackage || false,
                          isEvent: scheduleDetail?.isEvent || false,
                          selectedEventPricing: scheduleDetail?.eventPricingList.map((priceData) => {
                            return {
                              "bookingQty": 1,
                              // "totalPrice": priceData.amount,
                              "ticketType": priceData.ticketType,
                            }
                          }) || [],
                          username: values.username,
                          fullName: values.fullName,
                          email: values.email,
                          isPaid: false,
                          paymentMethod: "payAtVenue",
                          paymentMode: "NA",
                          paymentStatus: "Unpaid",
                        };
                        let allowToSubmit = false;
                        if (selectedMember && Object.keys(selectedMember).length > 0) {
                          let getMatchedVoucherDetail = getMatchedVoucher(selectedMember)
                          if (getMatchedVoucherDetail.status == true) {
                            allowToSubmit = true;
                            body = {
                              ...body,
                              isPaid: true,
                              paymentMethod: "classPass",
                              paymentMode: "Online",
                              paymentStatus: "Paid",
                              passVoucherCode: getMatchedVoucherDetail?.data?.passVoucherCode
                            }
                          }
                        }

                        if (allowToSubmit == true) {
                          const config = {
                            method: "post",
                            url: `${getUrlForBookings()}addClassBooking`,
                            data: body,
                          };

                          // console.log("config", config);
                          // return false;

                          dispatch(setActionLoading(true));
                          const request = await axiosInstance(config);
                          dispatch(setActionLoading(false));
                          if (request.status === 200) {
                            if (request.data.statusCode === 200) {
                              // addSuccessToast("Success!");
                              setSubmitting(false);
                              setSelectedMember({})
                              setMyMembersList([])
                              resetForm();
                              handleClose();
                              addNotificationDialog({
                                dialogType: "success",
                                dialogTitle: "",
                                dialogMessage: "Participant is added successfully",
                                dialogBtnTitle: "Ok",
                                dialogBackdropClick: async () => {
                                  handleUpdate();
                                },
                                dialogBtnClick: async () => {
                                  handleUpdate();
                                }
                              })
                              // handleUpdate();
                            } else {
                              addErrorToast(request.data.message);
                              setSubmitting(false);
                            }
                          }
                        } else {
                          setErrors({ username: "This member do not have any credits to book this session." })
                        }
                      }}
                    >
                      {({ isValid, values, errors, setValues, setFieldValue, submitForm, isSubmitting, handleBlur, }) => (
                        <Form className="flex flex-col gap-4 w-full min-h-64">
                          <TwAutocomplete
                            label={"Select Member"}
                            name={"username"}
                            isAsync={true}
                            errors={errors}
                            options={myMembersList}
                            optionView={(data) => {
                              // console.log("selected member", newValue);
                              let getMatchedVoucherDetail = getMatchedVoucher(data)
                              // console.log("selected member", data);
                              return (<div className="flex justify-start items-start gap-3 w-full ">
                                <div className="flex-none pt-2">
                                  {data?.consumer_detail?.profilePic ? (<img
                                    className="size-8 rounded-full"
                                    src={data.consumer_detail.profilePic}
                                    alt={``}
                                  />) : (<img
                                    className="size-8 rounded-full"
                                    src={profile_img}
                                    alt={``}
                                  />)}
                                </div>
                                <div className="[w-28]">
                                  {/* <div className="line-clamp-1">{data?.consumer_detail?.fullName}</div> */}
                                  <div className="flex gap-2 w-full items-center">
                                    <div className="line-clamp-1">{data?.consumer_detail?.fullName}</div>
                                    <div className="line-clamp-1 inline-flex items-center rounded-full bg-purple-100 px-2 py-1 text-xs font-medium text-purple-700">{getMatchedVoucherDetail.status == true ? <><span className="">{getMatchedVoucherDetail?.data.productType != undefined && getMatchedVoucherDetail?.data.productType == "subscription" ? (getMatchedVoucherDetail?.data.unlimitedCredits != undefined && getMatchedVoucherDetail?.data.unlimitedCredits == true ? "Unlimited Credits" : getMatchedVoucherDetail?.data.total_voucher_unused) : getMatchedVoucherDetail?.data?.total_voucher_unused || "0"}</span></> : "No Credits"}</div>
                                  </div>
                                  {/* <div className="text-sm text-gray-500 line-clamp-1">{(data.consumer_detail?.countryCode ? data.consumer_detail.countryCode + "_" + data.consumer_detail.phoneNumber : (data.consumer_detail?.email ? data.consumer_detail.email : ""))}</div> */}
                                  <div className="text-sm text-gray-500 line-clamp-1">{(data.consumer_detail?.email ? data.consumer_detail.email : "")}</div>
                                </div>
                              </div>)
                            }}
                            onChange={(newValue) => {
                              console.log("selected member", newValue.data || {});
                              setSelectedMember(newValue?.data || {})
                              setValues({
                                username: newValue?.data?.consumer_detail?.username || "",
                                fullName: newValue?.data?.consumer_detail?.fullName || "",
                                email: newValue?.data?.consumer_detail?.email || "",
                                selectedMember: newValue?.data || {},
                              });
                              // setFieldValue("username", newValue?.data?.consumer_detail?.username || "");
                              // setFieldValue("fullName", newValue?.data?.consumer_detail?.fullName || "");
                              // setFieldValue("email", newValue?.data?.consumer_detail?.email || "");
                            }}
                            onQueryChange={async (searchText) => {
                              // console.log("newValue", searchText);
                              if (searchText !== undefined && searchText.length <= 0) {

                              } else if (searchText.length > 3) {
                                await getMyClubMembers(searchText)
                              }

                            }}
                          />
                          <div className="grow">
                            {selectedMember && Object.keys(selectedMember).length > 0 && (() => {
                              let getMatchedVoucherDetail = getMatchedVoucher(selectedMember)
                              // console.log("getMatchedVoucherDetail", getMatchedVoucherDetail);

                              return (
                                <div className=" flex flex-col gap-2">
                                  <div className="flex justify-start items-start gap-3 w-full ">
                                    <div className="flex-none">
                                      {selectedMember?.consumer_detail?.profilePic ? (<img
                                        className="size-8 rounded-full"
                                        src={selectedMember.consumer_detail.profilePic}
                                        alt={``}
                                      />) : (<img
                                        className="size-8 rounded-full"
                                        src={profile_img}
                                        alt={``}
                                      />)}
                                    </div>
                                    <div className="w-full">
                                      {/* <div>{cutString(selectedMember?.studentName, 10, true)}</div> */}
                                      <div className="flex w-full">
                                        <div className="flex-1 line-clamp-1">{selectedMember?.consumer_detail?.fullName}</div>
                                        {/* <div className="line-clamp-1 inline-flex items-center rounded-full bg-purple-100 px-2 py-1 text-xs font-medium text-purple-700">{getMatchedVoucherDetail.status == true ? <><span className="">Credits Left: {getMatchedVoucherDetail?.data?.total_voucher_unused || "0"}</span></> : ""}</div> */}
                                      </div>
                                      <div className="text-sm text-gray-500 line-clamp-1">
                                        {(selectedMember.consumer_detail?.countryCode ? selectedMember.consumer_detail.countryCode + " " + selectedMember.consumer_detail.phoneNumber : "")}
                                      </div>
                                      <div className="text-sm text-gray-500 line-clamp-1">{(selectedMember.consumer_detail?.email ? selectedMember.consumer_detail.email : "")}</div>

                                    </div>
                                  </div>
                                  {selectedMember.purchase_detail && Array.isArray(selectedMember.purchase_detail) && selectedMember.purchase_detail.length > 0 && (<>
                                    <div className="relative">
                                      <div aria-hidden="true" className="absolute inset-0 flex items-center">
                                        <div className="w-full border-t border-gray-300" />
                                      </div>
                                      <div className="relative flex justify-center">
                                        <span className="bg-white px-2 text-sm text-gray-500">Credits</span>
                                      </div>
                                    </div>

                                    {selectedMember.purchase_detail.filter((f) => (f.classId != undefined
                                      && Array.isArray(f.classId)
                                      && (f.classId.length <= 0 || (f.classId.indexOf(scheduleDetail?.classId?._id || scheduleDetail?.classId || "") !== -1))
                                    )).map((purchaseDetail) => (<div className="inline-flex">
                                      {purchaseDetail.passName}:&nbsp;<span className="inline-flex items-center rounded-full bg-purple-100 px-2 py-1 text-xs font-medium text-purple-700">{purchaseDetail.productType != undefined && purchaseDetail.productType == "subscription" ? (purchaseDetail.unlimitedCredits != undefined && purchaseDetail.unlimitedCredits == true ? "Unlimited Credits" : purchaseDetail.total_voucher_unused) : purchaseDetail.total_voucher_unused}</span>
                                    </div>))}
                                  </>)}

                                </div>)
                            })()}
                          </div>
                          {/* <TwInputGroup
                            label={"Full Name"}
                            placeholder={"Full Name"}
                            name={"fullName"}
                            leftIcon={(<img className={""} src={customer_name} alt={""} />)}
                            onChange={(e) => {
                              setFieldValue("fullName", e.target.value);
                            }}
                            errors={errors}
                          />
                          <TwPhoneInputGroup
                            label={"Phone Number"}
                            placeholder={"Phone Number"}
                            name={"phone"}
                            country={values.countryName}
                            onBlur={() => handleBlur("phone")}
                            onChange={(phone, country, e) => {
                              const numberWithoutDialCode = phone.split("");
                              for (let i = 0; i < country.dialCode.length; i++) {
                                numberWithoutDialCode.shift();
                              }
                              let dialCode = country.dialCode;
                              if (
                                country.format.includes("+") &&
                                !country.dialCode.includes("+")
                              ) {
                                dialCode = "+".concat(country.dialCode);
                              }
                              setFieldValue("countryName", country.countryCode);
                              setFieldValue("countryCode", dialCode);
                              setFieldValue("phone", numberWithoutDialCode.join(""));
                              setFieldValue("formattedPhoneNumber", e.target.value);
                            }}
                            errors={errors}
                          />
                          <p className={"font-light text-sm text-center my-2"}>
                            This participant will be added to the class/course unpaid.
                            You can send Tikkie request for payments in the next step.
                          </p> */}
                          <TwButton
                            variant={"orange"}
                            onClick={submitForm}
                            disabled={loadingReduxState.actionLoading || Object.keys(selectedMember).length <= 0 || isValid != true}
                            actionLoading={(loadingReduxState.actionLoading)}
                          >
                            Add Participant
                          </TwButton>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
      <SuccessParticipantModal
        open={successModalOpen}
        handleClose={handleSuccessClose}
        fullName={fullName}
        phoneNumber={phoneNumber}
        bookingId={bookingId}
        handleUpdate={handleUpdate}
      />
    </>
  );
}
